(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gear-catalogue"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gear-catalogue')) {
  customElements.define('gear-catalogue', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.cards = Array.from(this.querySelectorAll('.gear-mvp__card'));
      this.facets = Array.from(this.querySelectorAll('[data-facet]'));
      this.grid = this.querySelector('.gear-mvp__grid');
      this.values = (card,key) => (card.dataset[key] || '').split(',').map(s=>s.trim()).filter(Boolean);
      const objectives = new URL(location.href).searchParams.getAll('objective');
      this.facets.forEach(group => {
        const key=group.dataset.facet;
        const values = Array.from(new Set(this.cards.flatMap(card=>this.values(card,key)))).sort();
        if(key==='objectives') {
          ['Glacier travel','General mountaineering','Ski mountaineering','Technical alpinism','Waterfall ice','Mixed climbing'].forEach(v=>{if(!values.includes(v))values.push(v);});
        }
        values.forEach(value=>{
          const button=document.createElement('button');
          button.type='button';
          button.className='gear-mvp__tag';
          button.textContent=value;
          button.dataset.value=value;
          button.setAttribute('aria-pressed',String(key==='objectives'&&objectives.includes(value)));
          button.addEventListener('click',()=>{
            button.setAttribute('aria-pressed',String(button.getAttribute('aria-pressed')!=='true'));
            this.update();
          });
          group.querySelector('.gear-mvp__tags').append(button);
        });
      });
      this.querySelectorAll('[data-guide-objective]').forEach(button=>{
        button.addEventListener('click',()=>{
          this.querySelectorAll('.gear-mvp__tag').forEach(tag=>{
            const match=tag.closest('[data-facet]').dataset.facet==='objectives' && tag.dataset.value===button.dataset.guideObjective;
            tag.setAttribute('aria-pressed',String(match));
          });
          this.querySelector('[data-available]').checked=false;
          this.update();
          const target=this.querySelector('.gear-mvp__toolbar');
          target.setAttribute('tabindex','-1');
          target.focus({preventScroll:true});
          target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
        });
      });
      this.querySelector('[data-available]').addEventListener('change',()=>this.update());
      this.querySelector('[data-sort]').addEventListener('change',()=>this.update());
      this.querySelector('[data-reset]').addEventListener('click',()=> {
        this.querySelectorAll('.gear-mvp__tag').forEach(b=>b.setAttribute('aria-pressed','false'));
        this.querySelector('[data-available]').checked=false;
        this.querySelector('[data-sort]').value='featured';
        this.update();
      });
      this.querySelector('[data-controls]').hidden=false;
      this.querySelector('[data-sort-control]').hidden=false;
      if(matchMedia('(max-width:989px)').matches) this.querySelector('details').open=false;
      this.update();
    }
    selected(group) {
      return Array.from(group.querySelectorAll('[aria-pressed="true"]')).map(b=>b.dataset.value);
    }
    update() {
      const objectives=this.selected(this.querySelector('[data-facet="objectives"]'));
      let count=0;
      const available=this.querySelector('[data-available]').checked;
      const sort=this.querySelector('[data-sort]').value;
      const cards=[...this.cards];
      if(sort!=='featured') cards.sort((a,b)=>(Number(a.dataset.price)-Number(b.dataset.price))*(sort==='low'?1:-1));
      cards.forEach(card=>{
        const show=this.facets.every(group=>{
          const chosen=this.selected(group);
          return !chosen.length||chosen.some(v=>this.values(card,group.dataset.facet).includes(v));
        })&&(!available||card.dataset.available==='true');
        card.hidden=!show;
        if(show) count++;
        this.grid.append(card);
      });
      this.querySelector('[data-count]').textContent=count;
      this.querySelector('[data-empty]').hidden=count!==0;
      const current=new URL(location.href);
      current.searchParams.delete('objective');
      objectives.forEach(value=>current.searchParams.append('objective',value));
      history.replaceState(history.state,'',current.href);
      this.querySelectorAll('[data-gear-nav]').forEach(link=>{
        const url=new URL(link.href);
        const preview=current.searchParams.get('preview_theme_id');
        if(preview)url.searchParams.set('preview_theme_id',preview);
        url.searchParams.delete('objective');
        objectives.forEach(value=>url.searchParams.append('objective',value));
        link.href=url.href;
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ski-selector"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ski-browser]').forEach((browser) => {
    if (browser.dataset.ready === 'true') return;
    browser.dataset.ready = 'true';

    const rail = browser.querySelector('[data-ski-rail]');
    const cards = Array.from(browser.querySelectorAll('[data-ski-card]'));
    const filters = Array.from(browser.querySelectorAll('[data-ski-filter]'));
    const empty = browser.querySelector('[data-ski-empty]');
    const step = () => Math.min(rail.clientWidth * 0.82, 430);

    filters.forEach((button) => {
      button.addEventListener('click', () => {
        const selected = button.dataset.skiFilter;
        filters.forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        let visibleCount = 0;
        cards.forEach((card) => {
          const visible = selected === 'all' || card.dataset.skiType === selected;
          card.hidden = !visible;
          if (visible) visibleCount += 1;
        });
        empty.hidden = visibleCount !== 0;
        rail.scrollTo({ left: 0, behavior: 'smooth' });
      });
    });

    browser.querySelector('[data-ski-previous]').addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
    browser.querySelector('[data-ski-next]').addEventListener('click', () => rail.scrollBy({ left: step(), behavior: 'smooth' }));
  });

  } catch(e) { console.error(e); }
})();
})();
